/**
 * PAU's analytics entry point. Fires existing Voltron events that thd-analytics already
 * listens for, so PAU-native cards (LatestOrdersCard is the first) don't need new
 * listeners and share one window/event-bus guard instead of re-implementing it inline.
 */
export const triggerViewAllOrdersAnalytics = () => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('recentPurchases.view-all-orders-click');
  }
};
